import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import iconFilter from 'assets/icon-filter.png';
import buildActualPath from 'helpers/build-actual-path';
import FlexGroup from 'components/FlexGroup';
import Blocker from 'components/Blocker';
import { I18n, Translate } from 'react-redux-i18n';
import { FILTER_MANAGEMENT } from 'constants/routes';
import FilterResult from './FilterResult';

import { useGetPinnedFiltersQuery } from 'redux/hook/useFilter';

import './filter-shortcut.scss';


const FilterShortcut = () => {
    const [open, setOpen] = useState(false);
    const { data } = useGetPinnedFiltersQuery();
    const filterList = data ?? [];
    const toggleFilterShortcutList = () => {
        setOpen(!open);
    };

    return (
        <FlexGroup className="filter-shortcut">
            {
                open ? (
                    <Blocker onClick={ toggleFilterShortcutList }>
                        <FlexGroup className="filter-shortcut-wrapper">
                            <Translate tag="p" className="filter-shortcut-title" value="filters.shortcut_title" />
                            <ul className="filter-shortcut-list">
                                {
                                    (filterList.length === 0) ? (
                                        <li className="empty">
                                            <Translate value="filters.empty_filters" />
                                        </li>
                                    ) : null
                                }
                                {
                                    filterList.map(item => (
                                        <li key={ item.id } onClick={ item.has_permission ? toggleFilterShortcutList : () => {} } className={ item.has_permission ? undefined : 'disabled' }>
                                            {
                                                item.has_permission ? (
                                                    <FilterResult
                                                        type={ item.type }
                                                        payload={ item.criteria }
                                                        context={ item.name }
                                                    />
                                                ) : (
                                                    <span>{ item.name }</span>
                                                )
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                            <NavLink
                                className="filter-shortcut-item-go btn btn-outline-primary"
                                to={ buildActualPath(FILTER_MANAGEMENT) }
                                onClick={ toggleFilterShortcutList }
                            >
                                <Translate value="filters.go_to_filters_management" />
                            </NavLink>
                        </FlexGroup>
                    </Blocker>
                ) : null
            }
            <img
                className="avatar"
                src={ iconFilter }
                alt={ I18n.t('filters.shortcut_title') }
                onClick={ toggleFilterShortcutList }
            />
        </FlexGroup>
    );
};
export default FilterShortcut;
